export class OpportunityCategoryType {
  constructor(
    public id: string = null,
    public name: string = null
  ) { }
}
